import "./Vinput.scss";

export default {
  props: {
    classes: {
      type: Array,
      default: () => [],
    },
    label: String,
    name: String,
    type: String,
    icon: String,
    iconText: String,
    value: String,
    prepend: String,
    focus: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    colorScheme: String,
    clear: Boolean,
    enterFunc: {
      type: Function,
      default: () => null,
    },
    inputFunc: {
      type: Function,
      default: () => null,
    },
    properties: {
      type: Object,
      default: () => {},
    },
    link: {
      type: Object,
      default: () => {},
    },
    underText: String,
    size: String,
  },
  data() {
    return { inputVal: this.value };
  },
  methods: {
    buildClasses() {
      const result = [];

      if (this.classes) {
        result.concat(this.classes);
      }

      if (this.colorScheme) {
        result.push(`vinput--${this.colorScheme}`);
      }

      if (this.icon && this.icon !== "text") {
        result.push(`vinput--icon`);
      }

      if (this.size) {
        result.push(`vinput--${this.size}`);
      }

      return result;
    },
    buildLinkProps() {
      const extraClasses = [
        "vinput__link",
        "label--tiny",
        "label--small-strong-d",
      ];

      if (this.link != {} && this.link != undefined) {
        if (this.link.classes) {
          const newClasses = this.link.classes;

          //add extra classes
          extraClasses.forEach((classItem) => {
            if (newClasses.indexOf(classItem) === -1) {
              newClasses.push(classItem);
            }
          });

          this.link.classes = newClasses;
        } else {
          this.link.classes = extraClasses;
        }

        //if color scheme is present push this aswell
        if (this.colorScheme) {
          this.link.colorScheme = this.colorScheme;
        }

        return this.link;
      }

      return {};
    },
    focusMe() {
      this.$refs.input.focus();
    },
  },
  watch: {
    clear() {
      this.inputVal = "";
    },
    value() {
      this.inputVal = this.value;
    },
    focus() {
      this.focusMe();
    },
  },
};
